import { kyApiClient } from '@polaris/core/utils'

export const apiClient = kyApiClient
